import React, { useState } from 'react';

interface GameDataProps {
  data: Record<string, any>;
}

export const GameData: React.FC<GameDataProps> = ({ data }) => {
  const [open, setOpen] = useState(false);
  return (
    <details onToggle={event => setOpen(event.currentTarget.open)}>
      <summary>GameData</summary>
      {open && <div className="game-data">
      {Object.entries(data).map(([key, value]) => {
        if (key === 'message') return null;
        if (key === 'gameLog') return null;
        return (
          <div key={key} className="data-item">
            <strong>{key}:</strong> {JSON.stringify(value)}
          </div>
        );
      })}
      </div>}
    </details>
  );
};
